import { CheckButton, Panel, PanelTheme, PanelBorderStyle, PanelBorderRadius } from '@apply/components';
import { paymentAgreement } from '@apply/constants';
import { isMobileScreen } from '@apply/ui';
import { useState, useRef } from 'react';

interface PaymentAgreementCheckButtonProps {
    paymentAgreementAccepted: boolean;
    set_paymentAgreementAccepted: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PaymentAgreementCheckButton: React.FC<PaymentAgreementCheckButtonProps> = ({
    paymentAgreementAccepted,
    set_paymentAgreementAccepted,
}) => {
    const mobileScreen = isMobileScreen();
    const scrollRef = useRef<HTMLDivElement>(null);
    const [scrolledToBottom, setScrolledToBottom] = useState(false);

    const handleScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
        if (atBottom) setScrolledToBottom(true);
    };
    return (
        <>
            <div className='customPaymentAgreementContainer'>
                <h4>Legal Acknowledgement - Please Read</h4>
                <br />
                <Panel
                    theme={PanelTheme.Gray}
                    borderStyle={PanelBorderStyle.Solid}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    <div
                        className='payment-agreement'
                        ref={scrollRef}
                        onScroll={handleScroll}
                    >
                        {paymentAgreement}
                    </div>
                </Panel>
                <div className='customPaymentAgreement-checkButton'>
                    <CheckButton
                        id='paymentAgreement'
                        selected={paymentAgreementAccepted}
                        onToggle={() => set_paymentAgreementAccepted(!paymentAgreementAccepted)}
                        label='I understand and agree'
                        width={mobileScreen ? '100%' : '250px'}
                        disabled={!scrolledToBottom}
                    />
                </div>
            </div>
        </>
    );
};
